// Minimal web-safe shim for React Native's codegenNativeComponent.
// Some React Native libraries import this module even when running on web.
// Vite/esbuild cannot parse Flow "import type" syntax in the real react-native implementation.
// Returning a null component is sufficient for web-only rendering paths.

import type React from 'react';

type AnyProps = Record<string, unknown>;

type ComponentType = React.ComponentType<AnyProps>;

export default function codegenNativeComponent(_name: string): ComponentType {
  const NullComponent: ComponentType = () => null;
  return NullComponent;
}
